// TODO - Documentar
import React, { useRef, useEffect } from 'react'
import * as d3 from "d3";
import { wrap } from '../ChartFunctions';
import { LABEL, NAME, VALUE, X_LABEL_FONT_SIZE, Y_LABEL_FONT_SIZE } from '../ChartConstants';


// Simple Bar chart based on D3

/**
 * Data must be passed with the following structure
 * Array of objects. Each object must include:
 *  - name : string with name
 *  - value : value for the chart
 *  - label : label
 */


function SimpleBarChart({ data, dimensions, parameters }) {

    const svgRef = useRef(null);

    // Parameters
    const xLabelFontSize = parameters[X_LABEL_FONT_SIZE];
    const yLabelFontSize = parameters[Y_LABEL_FONT_SIZE];

    // Dimensions
    const { width, height, margin } = dimensions;
    const svgWidth = width + margin.left + margin.right;
    const svgHeight = height + margin.top + margin.bottom;

    useEffect(() => {
        if (!svgRef.current || !data || data.length === 0) return;

        const svgEl = d3.select(svgRef.current);
        svgEl.selectAll('*').remove();

        // X and Y scales
        const x = d3.scaleBand().range([0, width]).padding(0.1)
            .domain(data.map((d) => d[NAME]));
        const y = d3.scaleLinear().range([height, 0])
            .domain([0, Math.max(1, ...data.map((d) => d[VALUE]))]);

        const svg = svgEl.append('g')
            .attr('transform', `translate(${margin.left},${margin.top})`);

        // Bars
        svg.selectAll('.bar')
            .data(data)
            .enter().append('rect')
            .attr('class', 'bar')
            .attr('fill', 'var(--primary-color-6)')
            .attr('x', (d) => x(d[NAME]))
            .attr('width', x.bandwidth())
            .attr('y', (d) => y(d[VALUE]))
            .attr('height', (d) => Math.max(0, height - y(d[VALUE])))
            .style('opacity', 0.8)
            .on('mouseover', function () {
                d3.select(this).transition().duration(200).style('opacity', 1);
            })
            .on('mouseout', function () {
                d3.select(this).transition().duration(200).style('opacity', 0.8);
            })
            .append('svg:title')
            .text((d) => `${d[NAME]}: ${d[LABEL]}`);

        // X axis
        svg.append('g')
            .style('font-size', xLabelFontSize + 'px')
            .attr('transform', `translate(0,${height})`)
            .call(d3.axisBottom(x))
            .selectAll('.tick text')
            .call(wrap, x.bandwidth());

        // Y axis (integer ticks)
        const maxVal = Math.max(1, ...data.map((d) => d[VALUE]));
        svg.append('g')
            .style('font-size', yLabelFontSize + 'px')
            .call(d3.axisLeft(y).ticks(Math.min(5, maxVal)).tickFormat(d3.format('d')));

    }, [data, width, height, margin, xLabelFontSize, yLabelFontSize]);

    return (
        <div>
            <svg ref={svgRef} width={svgWidth} height={svgHeight} />
        </div>
    );
}


SimpleBarChart.defaultProps = {
    parameters: {
        [X_LABEL_FONT_SIZE]: 12,
        [Y_LABEL_FONT_SIZE]: 12,
    },
    dimensions: {
        width: 400,
        height: 200,
        margin: { top: 20, right: 30, bottom: 50, left: 40 },
    },
};

export default SimpleBarChart
